export const fleetPageRouteName = "/master-data/fleet";
export const addFleetPageRouteName = "/master-data/fleet/add";
export const editFleetPageRouteName = (id?: string) => `/master-data/fleet/edit/${id ?? ":id"}`;
export const detailFleetPageRouteName = (id?: string) => `/master-data/fleet/detail/${id ?? ":id"}`;
